"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * 折疊樹狀
 */
var Panel = _antd.Collapse.Panel;

var CollapseTree = function CollapseTree(_ref) {
  var _ref$dataFetching = _ref.dataFetching,
      dataFetching = _ref$dataFetching === void 0 ? false : _ref$dataFetching,
      _ref$accordion = _ref.accordion,
      accordion = _ref$accordion === void 0 ? true : _ref$accordion,
      _ref$treeData = _ref.treeData,
      treeData = _ref$treeData === void 0 ? [] : _ref$treeData,
      _ref$panelData = _ref.panelData,
      panelData = _ref$panelData === void 0 ? [] : _ref$panelData,
      _ref$checkedList = _ref.checkedList,
      checkedList = _ref$checkedList === void 0 ? [] : _ref$checkedList,
      _ref$activeKey = _ref.activeKey,
      activeKey = _ref$activeKey === void 0 ? [] : _ref$activeKey,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onPanelChange = _ref.onPanelChange,
      onPanelChange = _ref$onPanelChange === void 0 ? function () {} : _ref$onPanelChange;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      autoExpandParent = _useState2[0],
      setAutoExpandParent = _useState2[1];

  var onExpand = function onExpand(expandedKeysValue) {
    setAutoExpandParent(false);
  };

  var onCheck = function onCheck(checkedKeysValue) {
    onChange && onChange(checkedKeysValue);
  };

  function callback(key) {
    onPanelChange && onPanelChange(key);
  }

  var collapsible = (0, _react.useMemo)(function () {
    return dataFetching ? "disabled" : "";
  }, [dataFetching]);
  return /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
    activeKey: activeKey,
    collapsible: collapsible,
    accordion: accordion,
    onChange: callback
  }, panelData && panelData.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(Panel, {
      header: item.name,
      key: index
    }, dataFetching ? "loading..." : /*#__PURE__*/_react.default.createElement(_antd.Tree, {
      checkable: true,
      onExpand: onExpand,
      autoExpandParent: autoExpandParent,
      onCheck: onCheck,
      checkedKeys: checkedList,
      treeData: treeData,
      selectable: false
    }));
  }));
};

var _default = CollapseTree;
exports.default = _default;
CollapseTree.propTypes = {
  activeKey: _propTypes.default.any,
  dataFetching: _propTypes.default.bool,
  accordion: _propTypes.default.bool,
  treeData: _propTypes.default.array,
  panelData: _propTypes.default.array,
  checkedList: _propTypes.default.array,
  onChange: _propTypes.default.func,
  onPanelChange: _propTypes.default.func
};